import React, {useState} from 'react';
import {Button, Container} from "react-bootstrap";
import {CustomButton} from "../components";
import NextIcon from "../assets/next-icon";
import {PATH_APP} from "../routes/paths";
import ReactCodeInput from "react-verification-code-input";
import useAuth from "../hooks/useAuth";
import useIsMountedRef from "../hooks/useIsMountedRef";
import {useNavigate} from "react-router";
import {useForm} from "react-hook-form";
import {FormProvider} from "../components/hook-form";
import axios from '../utils/axios';
import {toast, ToastContainer} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';


function Verify() {
    const {verifyMethod} = useAuth();
    let navigate = useNavigate();

    const isMountedRef = useIsMountedRef();
    const [code, setCode] = useState();
    const [error, setError] = useState();
    const [message, setMessage] = useState();
    const methods = useForm();

    const {
        reset,
        clearErrors,
        handleSubmit,
        formState: {errors, isSubmitting},
    } = methods;
    const resend = async () => {
        try {
            let mobile = localStorage.getItem('mobile');
            const response = await axios.post('/resend', {
                mobile: mobile
            })
            const {message} = response.data;
            setMessage(message)
        } catch (error) {
            setError("خطا در ارسال مجدد")
        }
    }
    const onSubmit = async (data) => {
        try {
            await verifyMethod(code).then((response) => {
                if (!response.data.data.user?.user_information) {
                    navigate(PATH_APP.verifySuccess)
                }
            });
            //
        } catch (error) {
            reset();
            setMessage('')
            if (error.errors?.code) {
                setError(error.errors.code[0]);
            }
            clearErrors();
        }

    };
    return (
        <div id="verify-page">
            <div id="verify-header" className="d-flex flex-column justify-content-center align-items-center" style={{height:"260px"}}>
                <Container>
                    <h1 className="text-white">
                        اندام بــــرتر
                    </h1>
                    <p className="text-white mb-4">
                        با راهنمایی های ما اندام موردنظرت رو بساز!
                    </p>
                </Container>
            </div>
            <Container>
                <ToastContainer/>

                <div>
                    <h2 className="mt-4 page-title">احراز شماره تلفن</h2>
                    <p className="page-hint"> یک کد شش رقمی به شماره شما ارسال شد لطفا کد را وارد کنید .</p>
                </div>
                <>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <div className="verify-inputs">
                            <ReactCodeInput name="code" type="number" id="code" onChange={(e) => {
                                setCode(e)
                            }}/>
                            {error && <p className="text-danger text-center font-weight-bold mt-2">{error}</p>}

                        </div>
                        <div className="text-center mt-5">
                            {message && <p className="text-success">{message}</p>}
                            <a onClick={handleSubmit(resend)}>ارسال دوباره کد</a>
                        </div>
                        <footer className=" mt-5 mb-3">
                            <CustomButton>
                                <NextIcon/>
                                <span>مرحله بعدی</span>
                            </CustomButton>
                            {/* <div className="text-center p-2">
                                <span>شماره اشتباه است؟</span> <Link to={PATH_AUTH.login}>تغییر شماره همراه</Link>
                            </div>*/}
                        </footer>
                    </FormProvider>
                </>
            </Container>
        </div>
    );
}

export default Verify;
